module.exports = __webpack_public_path__ + "img/Ride_hero.cf2e24a6.png";